import { Reveal } from "./Reveal";
import { Eyebrow } from "./Shared";
import { PhotoSlot } from "./PhotoSlot";
import { site } from "@/site.config";

const cells = [
  { outlet: "Forbes 30 Under 30 Mexico", topic: "Recognition" },
  { outlet: "TOKEN2049", topic: "CryptoNews Spotlight" },
  { outlet: "Leaders in Islamabad", topic: "2025" },
  { outlet: "TheBlock Talks", topic: "Interview" },
];

const gallery = ["IMG_GALLERY_1", "IMG_GALLERY_2", "IMG_GALLERY_3"];

export default function Press() {
  return (
    <section id="rooms" data-testid="rooms-section" className="scroll-mt-20 bg-brand-n2 py-24 lg:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6">
        <Reveal>
          <Eyebrow>World Tour</Eyebrow>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-navy sm:text-4xl lg:text-5xl">
            A world tour to grow stakeholders,{" "}
            <span className="text-brand-orange">not spectators.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-navy/70 sm:text-lg">
            Twenty-two cities. The vision, in person. Each room is a bet that people who
            understand u-topia will help own what comes next. A community with one picture of
            the future, growing city by city. Then Bangkok.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {cells.map((c, i) => (
            <Reveal key={c.outlet} delay={i * 0.07}>
              <div data-testid={`rooms-cell-${i + 1}`} className="border-t-2 border-brand-orange pt-5">
                <p className="text-lg font-semibold tracking-tight text-navy">{c.outlet}</p>
                <p className="mt-1 text-sm text-navy/60">{c.topic}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {gallery.map((slotId, i) => (
            <Reveal key={slotId} delay={i * 0.07}>
              <PhotoSlot slotId={slotId} aspect="aspect-square" className="w-full" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
